import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};


// **1️⃣ Fetch Unread Messages API**
export const fetchUnreadMessages = createAsyncThunk(
    "chat/fetchUnreadMessages",
    async () => {
        try {
            const response = await myAxios.get("/chat/unread-messages");
            return { success: true, data: response.data.data };
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Something went wrong!" };
        }
    }
);

export const fetchUserList = createAsyncThunk(
    'user/fetchUserList',
    async (query) => {
        try {
            const response = await myAxios.get(`/user/all`);
            return { success: true, message: "User list fetched successfully!", data: response?.data?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updateUser = createAsyncThunk(
    'masters/updateUser',
    async (data) => {
        try {
            const response = await myAxios.put(`/user/update-billing/${data?.query?.usersId}`, data?.formData);
            return { success: true, message: "User updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

const userListSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        clearUserListData: state => {
            state.data = [];
        },
        setUserListData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const userListReducer = userListSlice.reducer;
export const { clearUserListData, setUserListData } = userListSlice.actions;

export const selectUserListData = (state) => state.userList.data;
